export default "__VITE_ASSET__BKWFi75W__"